import '@/index.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import CalizaCustomerDashboard from '@/CalizaCustomerDashboard';
import { ColorSchemeProvider } from '@/context/ColorSchemeProvider';
import { instrumentApplication } from '@/instrumentation/instrumentation';
import { store } from '@/StateManagement/ReduxStore';

instrumentApplication();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <ColorSchemeProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <CalizaCustomerDashboard />
        </LocalizationProvider>
      </ColorSchemeProvider>
    </Provider>
  </React.StrictMode>,
);
